<template>
  <div class="c-clients">
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title>
              Clients list
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                class="max-width-300 mr-5"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
              <v-select
                v-model="currentStatus"
                :items="clientStatuses"
                item-text="Status"
                item-value="Status"
                class="max-width-300"
                multiple
                hide-details
              >
                <template v-slot:prepend-item>
                  <v-list-item
                    ripple
                    @mousedown.prevent
                    @click="toggle"
                  >
                  <v-list-item-action>
                    <v-icon :color="selectAll ? 'primary' : ''">
                      {{ selectAll ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      Select All
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
              </v-select>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-data-table
                dense
                class="data-table"
                mobile-breakpoint="0"
                fixed-header
                :height="tableHeight"
                :headers="headers"
                :items="clients"
                :items-per-page="50"
                :search="search"
                :footer-props="{
                  'items-per-page-options': [10, 30, 50, -1]
                }"
                @click:row="onRowClick"
                @update:page="goTo"
              >
                <!-- Items -->
                <template v-slot:[`item`]='{ item }'>
                  <tr
                    :class="{
                      'red lighten-5': item.Is_Deleted
                    }"
                    @click.prevent="onRowClick(item)"
                  >
                    <td class="v-data-table__divider px-2 text-no-wrap" v-for="(key, itemKey) in headers" :key="itemKey">
                      <div v-if="key.value === 'Actions'">
                        <v-btn
                          text
                          small
                          color="primary"
                          @click.stop="showClientReports(item.Client_ID)"
                        >
                          Reports
                        </v-btn>
                        <v-btn
                          text
                          small
                          color="primary"
                          @click.stop="getClientProjects(item.Client_ID)"
                        >
                          Projects
                        </v-btn>
                        <v-btn
                          small
                          icon
                          color="primary"
                          @click.stop="editRow(item)"
                        >
                          <v-icon>mdi-pencil-circle</v-icon>
                        </v-btn>
                      </div>
                      <span v-else-if="key.value === 'Status'">{{ item[key.value] === false ? 'NotActive' : item.Is_Deleted ? 'Deleted' : 'Active'  }}</span>
                      <span v-else>{{ item[key.value] }}</span>
                    </td>
                  </tr>
                  <tr class="red lighten-4"
                    v-if="item.Is_Deleted"
                    @click.prevent="onRowClick(item)"
                  >
                    <td :colspan="headers.length" class="px-2 text-no-wrap">{{ item.Deleted_Notes }}</td>
                  </tr>
                </template>
                <!-- /Items -->
                <!-- Footer -->
                <template v-slot:[`footer`]>
                  <v-container fluid class="py-2">
                    <v-row>
                      <v-spacer></v-spacer>
                      <v-col cols="auto" v-if="canAdd">
                        <v-btn
                          color="success"
                          small
                          @click.prevent="showEditDialog"
                        >Add</v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </template>
                <!-- /Footer -->
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <ClientDetails
      v-if="showDetails"
      v-model="showDetails"
      :client="selectedClient"
      :editClient="editMode"
      @updateClient="updateClient"
      @createClient="createClient"
      :key="`details-key-${detailsDialogKey}`"
    />
    <v-dialog
      scrollable
      v-model="projectsDialog"
      max-width="500"
    >
      <v-card>
        <v-card-title>
          Projects
          <v-spacer></v-spacer>
          <v-text-field
            dense
            hide-details
            class="mr-3"
            label="Search Project"
            v-model="projectSearch"
            append-icon="mdi-magnify"
          ></v-text-field>
          <v-btn
            icon
            @click.prevent="projectsDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-4">
          <v-data-table
            dense
            :headers="projectsHeader"
            :items="projectsList"
            :items-per-page="-1"
            :search="projectSearch"
            hide-default-footer
          >
            <template v-slot:[`item.Actions`]="{ item }">
              <v-btn
                small
                text
                plain
                color="primary"
                class="my-2"
                @click="showProjectInfo(item.Project_ID)"
              >
                details...
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: 'Clients',
  components: {
    ClientDetails: () => import('@/components/clients/ClientDetails')
  },
  data () {
    return {
      search: '',
      showDetails: false,
      selectedClient: null,
      detailsDialogKey: 0,
      rolesOfCurrentUser: [],
      clientStatus: ['Active'],
      projectSearch: '',
      projectsDialog: false,
      projectsList: [],
      editMode: false,
      clientStatuses: [
        {
          Status: 'Active'
        },
        {
          Status: 'NotActive'
        },
        {
          Status: 'Deleted'
        }
      ],
      projectsHeader: [
        {
          text: 'Project Name',
          value: 'Description',
          divider: true,
          class: 'text-no-wrap'
        },
        {
          text: 'Project Status',
          value: 'Status_Description',
          divider: true,
          class: 'text-no-wrap'
        },
        {
          text: '',
          value: 'Actions',
          class: 'text-no-wrap'
        }
      ]
    }
  },
  computed: {
    tableHeight () {
      const windowW = window.innerWidth
      return windowW < 768 ? 'calc(100vh - 280px)' : 'calc(100vh - 290px)'
    },
    headers () {
      return [
        {
          text: 'Name',
          value: 'Name',
          divider: true,
          class: 'px-2 text-no-wrap'
        },
        {
          text: 'Address',
          value: 'Address',
          divider: true,
          class: 'px-2 text-no-wrap'
        },
        {
          text: 'Status',
          value: 'Status',
          divider: true,
          class: 'px-2 text-no-wrap'
        },
        {
          text: 'Notes',
          value: 'Notes',
          divider: true,
          class: 'px-2 text-no-wrap'
        },
        {
          text: '',
          value: 'Actions',
          divider: true,
          width: '200px',
          sortable: false,
          class: 'px-2 text-no-wrap'
        }
      ]
    },
    user () {
      return this.$store.getters.getUser
    },
    clients () {
      const clients = this.$store.getters.getClients
      let res = []
      let active = []
      let notActive = []
      let deleted = []
      if (this.selectAll) {
        res = clients
        return res
      } else {
        if (this.currentStatus.includes('Active')) {
          active = clients.filter(item => item.Status !== false && !item.Is_Deleted)
        }
        if (this.currentStatus.includes('NotActive')) {
          notActive = clients.filter(item => item.Status === false && !item.Is_Deleted)
        }
        if (this.currentStatus.includes('Deleted')) {
          deleted = clients.filter(item => item.Is_Deleted)
        }
        res = active.concat(notActive, deleted)
        return res
      }
    },
    canAdd () {
      let res = false
      for (let i = 0; i < this.rolesOfCurrentUser.length; i++) {
        if (['manager', 'financier', 'hr'].indexOf(this.rolesOfCurrentUser[i].RoleName.toLowerCase()) > -1) {
          res = true
          break
        }
      }
      return res
    },
    projects () {
      return this.$store.getters.getProjects
    },
    currentStatus: {
      get () {
        return this.clientStatus
      },
      set (val) {
        this.clientStatus = val
      }
    },
    selectAll () {
      return this.currentStatus.length === this.clientStatuses.length
    }
  },
  async mounted () {
    await this.getRolesOfCurrentUser()
    if (!this.clients.length) {
      this.getClients()
    }
    if (!this.projects.length) {
      await this.getProjects()
    }
  },
  methods: {
    async getRolesOfCurrentUser () {
      await this.axios.get('/api/employee_role/' + this.user.login, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(result => {
        this.rolesOfCurrentUser = result.data
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    async getProjects () {
      await this.axios.get('/api/projects', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(response => {
        const proj = []
        for (let i = 0; i < response.data.length; i++) {
          let integratedWith = ''
          if (response.data[i].Integrated_With_Jira) integratedWith = 'Jira'
          if (response.data[i].Integrated_With_Redmine) integratedWith = 'Redmine'
          proj.push({
            ...response.data[i],
            Integrated_With: integratedWith
          })
        }
        this.$store.dispatch('setProjects', { projects: proj })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    onRowClick (e) {
      this.editMode = false
      this.showDetails = true
      this.selectedClient = e
      this.detailsDialogKey++
    },
    editRow (e) {
      this.editMode = true
      this.showDetails = true
      this.selectedClient = e
      this.detailsDialogKey++
    },
    goTo () {
      this.$vuetify.goTo(
        '.data-table tbody tr',
        {
          offset: 50,
          container: '.v-data-table__wrapper'
        }
      )
    },
    getClients () {
      this.axios.get('/api/clients', {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(response => {
        this.$store.dispatch('setClients', { clients: response.data })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    showEditDialog () {
      this.selectedClient = {
        Client_ID: null,
        Name: '',
        Address: '',
        Is_Deleted: false,
        Deleted_Notes: null,
        Phone: '',
        Email: '',
        Status: true,
        Notes: '',
        Website: '',
        Payment_Method: ''
      }
      this.showDetails = true
      this.detailsDialogKey++
    },
    updateClient (e) {
      this.axios.put(`/api/clients/${e.Client_ID}`, e, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(response => {
        this.$store.dispatch('updateClient', { client: response.data[0] })
        this.$store.dispatch('setSuccess', { successMsg: 'Client successfully updated' })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    createClient (e) {
      this.axios.post('/api/clients', e, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(response => {
        this.$store.dispatch('addClient', { client: response.data[0] })
        this.$store.dispatch('setSuccess', { successMsg: 'Client successfully created' })
        this.showDetails = false
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    showClientReports (clientId) {
      this.$router.push({
        name: 'ManagerReports',
        params: {
          Client_ID: clientId
        }
      })
    },
    getClientProjects (clientId) {
      this.getProjectsByClient(clientId)
      this.projectsDialog = true
    },
    getProjectsByClient (clientId) {
      this.axios.get(`/api/projects_by_client_id/${clientId}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.projectsList = res.data
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    showProjectInfo (projectID) {
      const proj = this.projects.filter(p => p.Project_ID === projectID)[0]
      if (proj) {
        proj.Get_Date = proj.Get_Date ? new Date(proj.Get_Date).toISOString().substr(0, 10) : null
        proj.Start_Date = proj.Start_Date ? new Date(proj.Start_Date).toISOString().substr(0, 10) : null
        proj.Release_Date = proj.Release_Date ? new Date(proj.Release_Date).toISOString().substr(0, 10) : null
        this.$store.dispatch('projectDetailsScreen', {
          show: true,
          project: proj
        })
      } else {
        this.$store.dispatch('setError', { errorMsg: 'Something went wrong!' })
      }
    },
    toggle () {
      if (this.selectAll) {
        this.currentStatus = []
      } else {
        this.currentStatus = this.clientStatuses.slice()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .align-items-center {
    display: flex;
    justify-content: center;
  }
  .max-width-300 {
    max-width: 300px;
  }
</style>
